import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import PageLayout from "../components/layout/PageLayout";
import { useAuth, formatApiError } from "../lib/auth";
import { LOGO_GOLD } from "../lib/constants";

export default function Login() {
    const nav = useNavigate();
    const loc = useLocation();
    const { login } = useAuth();
    const [form, setForm] = useState({ email: "", password: "" });
    const [busy, setBusy] = useState(false);

    const setF = (k, v) => setForm(f => ({ ...f, [k]: v }));

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            const user = await login(form.email, form.password);
            toast.success(`Welcome, ${user.name}`);
            const dest = loc.state?.from ||
                (["super_admin","founder","athlete_agent","compliance","finance","social_manager","content_creator"].includes(user.role)
                    ? "/mgmt/dashboard"
                    : user.role === "sponsor" ? "/sponsor/dashboard" : "/athlete/dashboard");
            nav(dest);
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <PageLayout noFooter>
            <section className="min-h-[calc(100vh-68px)] flex items-center py-16">
                <div className="max-w-md mx-auto w-full px-5">
                    <div className="text-center mb-10">
                        <img src={LOGO_GOLD} alt="Digital Beast" className="h-14 mx-auto" />
                        <h1 className="font-display text-4xl text-white mt-6 tracking-tight" data-testid="login-heading">WELCOME BACK</h1>
                        <p className="text-white/50 text-sm mt-3">Log in to your Digital Beast account.</p>
                    </div>
                    <form onSubmit={submit} className="surface p-8 space-y-5" data-testid="login-form">
                        <div>
                            <label className="db-label">Email</label>
                            <input type="email" required className="db-input-block" value={form.email} onChange={e => setF("email", e.target.value)} data-testid="login-email" />
                        </div>
                        <div>
                            <label className="db-label">Password</label>
                            <input type="password" required className="db-input-block" value={form.password} onChange={e => setF("password", e.target.value)} data-testid="login-password" />
                        </div>
                        <button type="submit" disabled={busy} className="btn-gold w-full justify-center" data-testid="login-submit">
                            {busy ? "Signing in…" : "Sign In"}
                        </button>
                        <div className="text-center text-sm text-white/50">
                            No account? <Link to="/register" className="text-[#d4af37] hover:underline" data-testid="login-register-link">Create one</Link>
                        </div>
                    </form>
                    <div className="mt-6 text-center text-xs text-white/40 leading-relaxed">
                        Demo accounts:<br/>
                        <span className="font-mono">admin@digitalbeast.com · Beast2026!</span><br/>
                        <span className="font-mono">athlete@example.com · Athlete2026!</span><br/>
                        <span className="font-mono">sponsor@example.com · Sponsor2026!</span>
                    </div>
                </div>
            </section>
        </PageLayout>
    );
}
